import { connect } from 'react-redux'
import { selectLanguage } from 'store/locales'
import ArticleThree from '../components/ArticleThree'

const mapStateToProps = ({ strings }) => {
  return {
    strings,
  }
}

const mapDispatchToProps = {
  selectLanguage,
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleThree)